import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Price from "@/pages/Price";
import Invite from "@/pages/Invite";
import NotFound from "@/pages/NotFound";
import "@/App.scss";
// import DataPreview from "@/pages/DataPreview";
// import XHS from "@/pages/XiaoHongShu/page";
import { DataContext } from "@/context";
import eventBus from "@/event/event";
import { useCheckVip } from '@/hooks/useInterval';
import { useCryptoStore } from '@/store/cryptoStore';
import CommercialOrder from '@/pages/CommercialOrder'

const DataProvider = DataContext.Provider

export type ContextValue = {
  userInfo: any;
  setContextValue: (newData: any) => void;
};

export const defaultContextValue: ContextValue = {
  userInfo: null,
  setContextValue: () => {},
};

const App: React.FC = () => {
  const [contextValue, setContextValue] = useState(defaultContextValue);

  const { handleGetCryptoMessage } = useCryptoStore()

  const { userOtherInfo, payCountObj } = useCheckVip(contextValue?.userInfo?.user_id)

  useEffect(() => {
    if (!contextValue?.userInfo?.user_id) {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        setContextValue((contextValue) => ({
          ...contextValue,
          userInfo: JSON.parse(userInfo)
        }))
      }
    }
  }, [contextValue?.userInfo?.user_id])

  useEffect(() => {
    eventBus.on('logout', () => {
      
      localStorage.removeItem('userInfo');
      setContextValue((contextValue) => ({
        ...contextValue,
        userInfo: {}
      }))
      window.location.replace(window.location.origin + '/#' + window.location.pathname)
    })
  }, [])

  return (
    <DataProvider value={{ ...contextValue, setContextValue }} > 
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home userOtherInfo={userOtherInfo} payCountObj={payCountObj}  />} />
          <Route path="price" element={<Price userOtherInfo={userOtherInfo} payCountObj={payCountObj} />} />
          <Route path="invite" element={<Invite userOtherInfo={userOtherInfo} payCountObj={payCountObj} />} />
        </Route>
        <Route path="commercial-order" element={<CommercialOrder userOtherInfo={userOtherInfo} payCountObj={payCountObj}/>} />
        {/* <Route path="xhs-preview" element={<XHS />} /> */}
        {/* <Route path="data-preview" element={<DataPreview userOtherInfo={userOtherInfo} payCountObj={payCountObj} />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    </DataProvider>
  );
};

export default App;
